import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch, useParams, useRouteMatch } from "react-router-dom";
import {
  clearCkycData,
  clearUser,
  getUserById,
  getUserVkycDetails
} from "../../../actions/user.action";
import Tabmenu from "../../../components/tabmenu";
import { UserDetails, VkycDetails } from "../../../dto";
import useScreenName from "../../../hooks/useScreenName";
import { ReactComponent as UserDocIcon } from "../../../images/document_file.svg";
import { ReactComponent as UserInfoIcon } from "../../../images/document_text.svg";
import { ReactComponent as EnquiriesIcon } from "../../../images/enquiries.svg";
import dispatch from "../../../middleware";
import { ReduxState } from "../../../reducers";
import { getUserSelfieDataUrl, isLoadingActive } from "../../../utils";
import UserAuditTrail from "../audit-trail";
import UserDocuments from "../documents";
import "../userDetailsStyles.css";
import UserWorkInformation from "../work-info";
import UserCreditReport from "./credit-report";
import UserInformation from "./userInformation";

export default function SingleUserScreen() {
  useScreenName("Users / Individual");
  const { userId } = useParams();
  const { url: pathUrl, path } = useRouteMatch();
  const storeDispatch = useDispatch();
  const userDetails: UserDetails | null = useSelector(
    (state: ReduxState) => state.user.singleUser,
  );
  const vkycDetails: VkycDetails | null = useSelector(
    (state: ReduxState) => state.user.vkycDetails,
  );
  const loadingQueue = useSelector(
    (state: ReduxState) => state.user.loadingQueue,
  );
  const [errorMessage, setErrorMessage] = useState("");
  const [selfieDataUrl, setSelfieDataUrl] = useState<string | null>(null);

  async function setUserSelfie() {
    const dataUrl = await getUserSelfieDataUrl(storeDispatch, userId);
    if (!dataUrl) return;
    setSelfieDataUrl(dataUrl);
  }

  async function fetchUserVkycDetails() {
    await dispatch(storeDispatch, getUserVkycDetails(userId));
  }

  useEffect(() => {
    dispatch(storeDispatch, getUserById(userId))
      .then(setUserSelfie)
      .catch((e) => setErrorMessage(e?.message));

    fetchUserVkycDetails();

    return () => {
      dispatch(storeDispatch, clearUser());
      dispatch(storeDispatch, clearCkycData());
    };
  }, [userId]);
  if (errorMessage) {
    return <h4 className="text-center">{errorMessage}</h4>;
  }
  if (!userDetails || userDetails._id !== userId) {
    return <h4 className="text-center">Loading...</h4>;
  }
  return (
    <>
      <Tabmenu
        items={[
          {
            name: "Information",
            path: `${pathUrl}`,
            exact: true,
            Icon: UserInfoIcon,
          },
          {
            name: "Work Information",
            path: `${pathUrl}/work-info`,
            exact: true,
            Icon: EnquiriesIcon,
          },
          {
            name: "Documents",
            path: `${pathUrl}/documents`,
            Icon: UserDocIcon,
          },
        ]}
      />
      <Switch>
        <Route path={`${path}/documents`}>
          <UserDocuments userDetails={userDetails} />
        </Route>
        <Route path={`${path}/credit-report`}>
          <UserCreditReport userDetails={userDetails} />
        </Route>
        <Route path={`${path}/work-info`}>
          <UserWorkInformation userId={userId} />
        </Route>
        <Route path={`${path}/`}>
          <UserInformation
            seflieUrl={selfieDataUrl}
            userDetails={userDetails}
            vkycDetails={vkycDetails}
            isLoading={isLoadingActive(loadingQueue)}
          />
          <UserAuditTrail userId={userId} />
        </Route>
      </Switch>
    </>
  );
}
